import React from "react";
import { Box, Typography } from "@mui/material";

const HeroImage = (props) => {
  return (
    <Box
      sx={{
        height: "60vh",
        textAlign: "center",
        backgroundImage: `url(${props.image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Typography
        sx={{
          position: "relative",
          top: "70%",
          fontSize: { xs: "2rem", sm: "2.7rem", md: "4rem", lg: "6rem" },
        }}
        variant="h1"
      >
        {props.text}
      </Typography>
    </Box>
  );
};

export default HeroImage;
